<template>
    <div class="service-container" @click="openService">
        <!-- 问题轮播 -->
        <div class="question-carousel">
            <div
                    v-for="(question, index) in questions"
                    :key="index"
                    class="question-item"
                    :class="{ active: currentIndex === index }"
            >
                {{ question }}
            </div>
        </div>

        <!-- 客服按钮 -->
        <button class="service-button" ><van-icon name="service" badge="6" /></button>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import open53 from "@/api/seviceBtn"
// 定义问题列表
const questions = ref([
    '学校费用多少？',
    '学校今年分数线？',
    '学校本科率多少？',
    '学校升学率如何？',
    '那个专业容易考本科？'
]);

// 当前显示的问题索引
const currentIndex = ref(0);
let rotationInterval = null;

// 定义5种配色方案
const colorSchemes = [
    {   // 方案1: 科技蓝
        name: 'tech-blue',
        bgColor: '#0052D9',
        textColor: '#FFFFFF',
        btnColor1: '#1A73E8',
        btnColor2: '#4285F4',
        btnRgb: '66, 133, 244'
    },
    {   // 方案2: 活力橙
        name: 'vibrant-orange',
        bgColor: '#FF6D00',
        textColor: '#FFFFFF',
        btnColor1: '#FF9100',
        btnColor2: '#FFAB40',
        btnRgb: '255, 171, 64'
    },
    {   // 方案3: 清新绿
        name: 'fresh-green',
        bgColor: '#00C853',
        textColor: '#FFFFFF',
        btnColor1: '#00E676',
        btnColor2: '#69F0AE',
        btnRgb: '105, 240, 174'
    },
    {   // 方案4: 热情红
        name: 'passion-red',
        bgColor: '#D50000',
        textColor: '#FFFFFF',
        btnColor1: '#FF1744',
        btnColor2: '#FF5252',
        btnRgb: '255, 82, 82'
    },
    {   // 方案5: 神秘紫
        name: 'mystic-purple',
        bgColor: '#6200EA',
        textColor: '#FFFFFF',
        btnColor1: '#7C4DFF',
        btnColor2: '#B388FF',
        btnRgb: '179, 136, 255'
    }
];

// 轮播问题
const rotateQuestions = () => {
    currentIndex.value = (currentIndex.value + 1) % questions.value.length;
};

// 打开客服
const openService = () => {
    open53()
};

// 应用随机配色方案
const applyRandomColorScheme = () => {
    const randomScheme = colorSchemes[Math.floor(Math.random() * colorSchemes.length)];
    document.documentElement.style.setProperty('--bg-color', randomScheme.bgColor);
    document.documentElement.style.setProperty('--text-color', randomScheme.textColor);
    document.documentElement.style.setProperty('--btn-color1', randomScheme.btnColor1);
    document.documentElement.style.setProperty('--btn-color2', randomScheme.btnColor2);
    document.documentElement.style.setProperty('--btn-rgb', randomScheme.btnRgb);
};

onMounted(() => {
    // 应用随机颜色
    applyRandomColorScheme();

    // 启动轮播
    rotationInterval = setInterval(rotateQuestions, 3500);
});

onBeforeUnmount(() => {
    // 清除定时器
    if (rotationInterval) {
        clearInterval(rotationInterval);
    }
});
</script>

<style scoped>
/* 客服按钮容器 */
.service-container {
    position: fixed;
    right: .875rem; /* 30px/16 */
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1000;
}

/* 呼吸动画效果 */
@keyframes breath {
    0% { box-shadow: 0 0 0 0 rgba(var(--btn-rgb), 0.7); }
    70% { box-shadow: 0 0 0 0.9375rem rgba(var(--btn-rgb), 0); } /* 15px/16 */
    100% { box-shadow: 0 0 0 0 rgba(var(--btn-rgb), 0); }
}

/* 圆形客服按钮 */
.service-button {
    width: 3.75rem; /* 60px/16 */
    height: 3.75rem; /* 60px/16 */
    border-radius: 50%;
    background: linear-gradient(135deg, var(--btn-color1), var(--btn-color2));
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    animation: breath 2s infinite;
    font-size: 1.5rem; /* 24px/16 */
    border: none;
    outline: none;
    transition: all 0.3s;
}

.service-button:hover {
    transform: scale(1.1);
}

/* 问题轮播区域 */
.question-carousel {
    width: 12.5rem; /* 200px/16 */
    background: var(--bg-color);
    border-radius: 0.5rem; /* 8px/16 */
    padding: 0.5rem 0.75rem; /* 8px/16, 12px/16 */
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1); /* 2px/16, 10px/16 */
    margin-bottom: 0.9375rem; /* 15px/16 */
    text-align: center;
    font-size: 0.875rem; /* 14px/16 */
    color: var(--text-color);
    overflow: hidden;
    min-height: 1.875rem; /* 30px/16 */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
}

/* 调整问题项间距 */
.question-item {
    position: absolute;
    width: 100%;
    text-align: center;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    padding: 0.125rem 0.625rem; /* 2px/16, 10px/16 */
    box-sizing: border-box;
}

.question-item.active {
    opacity: 1;
}
</style>
